<div class="flex items-center justify-between">
  <div class="flex items-center">
    <mat-icon svgIcon="view_timeline" class="mr-8"></mat-icon>
    <div class="mat-subtitle-2 mb-0 fs-24 fw-600">
      {{'INSTANCE_SUMMARY.UPDATE_CONFIGURATION.LOCAL_CONFIGURATION' | transloco}} 
      @if(haveReadAccess) {
      <span>({{searchTerm?.length > 0 && searchedResult ? searchedResult.length || 0 : (filteredConfigData?.length || 0)}})</span>
      }
    </div>
    @if(haveReadAccess) {
    <div class="ml-16 search-activity mt--24">
      <app-search-filter [ngClass]="{'disabled': showLoader || !localConfigData?.length || apiNotFound}" class="mt-20 ml-20" 
        placeholder="SEARCH.SEARCH" (changed)="search($event)"></app-search-filter>
    </div>
    <span class="vertical-dash ml-12"></span>
    <button [ngClass]="{'disabled': showLoader || !localConfigData?.length || apiNotFound}" 
      class="flex justify-center items-center context-menu-icon-filter height menu-btn pr-8 pl-8 pt-6 pb-6 ml-16 filter"
      (click)="filterClick()">
      <mat-icon svgIcon="filter_alt" class="mr-4"></mat-icon>
      <span class="fw-500 filters">{{'INSTANCE_DETAILS.FILTER' | transloco}}</span>
    </button>
  }
  </div>
@if(haveReadAccess) {
  <div class="flex flex-row gap-3">
    <div class="refresh-circle rounded-full w-32 h-32 flex items-center justify-center cursor-pointer" 
        (click)="refreshClick()">
      <mat-icon svgIcon="refresh" 
                class="icons transition-transform duration-700" 
                [ngClass]="{ 'animate-spin': showLoader }">
      </mat-icon>
    </div> 
    <app-environment-paginator 
      class="envt-paginator" 
      [length]="searchedResult?.length > 0 ? searchedResult?.length : filteredConfigData?.length" 
      [pageIndex]="pageIndex" 
      [pageSize]="paginationSize" 
      (page)="onPageChange($event)">
    </app-environment-paginator>
  </div>
}
</div>
@if(haveReadAccess) {
<!-- Filter Tags Section -->
<div *ngIf="filterStartDate && filterEndDate" class="flex flex-row items-center ml-8">
  @if (filterStartDate && filterEndDate) {
  <span class="mt-8 pr-8 fs-16">{{ 'TOOLBAR.CREATED_DATE' | transloco }}</span>
  }
  <div class="mt-8 mr-4 filtered-items flex items-center fs-16 fw-500" *ngIf="filterStartDate && filterEndDate">
    <span class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-2 pb-2 mr-16">
      {{ datePipe.transform(filterStartDate, 'dd MMM yyyy') }} - {{ datePipe.transform(filterEndDate, 'dd MMM yyyy') }}
      <span class="ml-8">
        <mat-icon svgIcon="close" class="cursor-pointer icon-sm" (click)="cancelDateFilter()"></mat-icon>
      </span>
    </span>
  </div>
</div>

<!-- Table Container -->
<div class="flex flex-col mt-16 details-container">
  <mat-divider class="title-divider"></mat-divider>
  @if ((applyingConfig  || data.localConfigStatus === 'applying') && !showLoader) {
  <div class="flex flex-row items-center config-info mb--2 mt-12 green">
    <mat-spinner diameter="24" class="w-24 h-24 mr-8"></mat-spinner>
    {{'BLUEPRINT_SUMMARY.APPLYING_CONFIG' | transloco }}
  </div>
  }
  @else if (data.localConfigStatus && !applyingConfig && !showLoader && data.localConfigStatus === 'failed') {
  <div class="flex flex-row items-center config-info mb--2 mt-12 warn">
      <div class="mr-6 icon-container">
        <mat-icon svgIcon='error_outline' class="icon icon-md warn-solid-fg"></mat-icon>
      </div>
      <span class="failed-color">{{('BLUEPRINT_SUMMARY.LOCAL_CONFIG_FAILED' | transloco)}}</span>
  </div>
}
  
  @if (!showLoader) {
  @if (filteredConfigData?.length > 0 || searchTerm?.length > 0 || (filterStartDate && filterEndDate)) {
  <div class="flex flex-col endpoints deploymentLogs envt-activity" [ngClass]="{'disabled': showLoader}">
    <app-environment-table class="mt-20" [initialDataSource]="filteredConfigData" [displayColumns]="displayColumns"
      [dataLoading]="showApplyLoader" (searchedResults)="searchedItems($event)" [searchTerm]="searchTerm"
      (selectRow)="select($event)" [showSkeletonLoader]="true" page="localConfiguration" pageName="localConfiguration"
      [dataSourceLength]="true" (sorted)="resetPaginator()" (applyLocalConfig)="applyLocalConfigConfirm($event)"
      (pageModify)="onTablePageChanged($event)" (pageChanged)="onPageChange($event)" [currentConfigVersion]="configVersion">
    </app-environment-table>
  </div>
  } @else if (!filteredConfigData?.length || apiNotFound) {
  <div class="flex flex-col">
    <div class="flex flex-col empty-panel ml-10 mr-16 mt-16">
      <div class="empty-data flex flex-col items-center mt-32">
        <img class="w-106" alt="runbook not found" src="/assets/images/service_not_found.png">
        <div class="flex mt-6">{{'SIZING.NO_LOCAL_CONFIG_DATA' | transloco }}</div>
      </div>
    </div>
  </div>
  }
  }
</div>
}
@if (showLoader) {
  <div class="loader-section mt-16">
    <div class="runbook-group loader-header flex flex-col p-16">
      <div class="flex flex-row">
        @for (tableColumn of displayColumns; track tableColumn?.key) {
          <div class="loader-style">
            <ngx-skeleton-loader class="flex loader-line mr-80" count="1" appearance="line">
            </ngx-skeleton-loader>
          </div>
        }
      </div>
    </div>
    @for (item of [1, 2, 3]; track $index) {
      <div class="w-100-percent">
        <div class="runbook-group flex flex-col p-16">
          <div class="flex flex-row">
            @for (tableColumn of displayColumns; track tableColumn?.key) {
              <div class="loader-style">
                <ngx-skeleton-loader class="flex loader-line mr-80" count="1" appearance="line">
                </ngx-skeleton-loader>
              </div>
            }
          </div>
        </div>
      </div>
    }
  </div>
}
@if(!haveReadAccess && !showLoader){
   <div class="pt-38 unauth-container pb-50 mb--20">
    <img class="image" src="/assets/images/unauthorized.svg">
    <div class="fw-600 fs-20 mat-subtitle-2 mt-32"> {{ 'UNAUTHORIZED.MESSAGE' | transloco }}</div>
  </div>
}